module.exports = __webpack_public_path__ + "img/google-calendar.ba9b56ca.png";